var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidersHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22V18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18V19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H17V22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22ZM12 19C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H12ZM7 14V13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H7V10C7 9.44771 7.44772 9 8 9C8.55228 9 9 9.44771 9 10V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H12C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11H21ZM13 6V2C13 1.44772 13.4477 1 14 1C14.5523 1 15 1.44772 15 2V3H21C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5H15V6C15 6.55228 14.5523 7 14 7C13.4477 7 13 6.55228 13 6ZM10 3C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H3C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersHorizontal);
export default __webpack_public_path__ + "static/media/sliders-horizontal.7a9e60d382a0724321b3683d99c75757.svg";
export { ForwardRef as ReactComponent };